module.exports = __webpack_public_path__ + "static/teacher-2-a22c96352af9872a9034f794ba7be3d5.jpg";